if (!customElements.get('faq-tabs')) {
  class FaqTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('[data-collapsible-faq-index]');
      this.groups = this.querySelectorAll('[data-collapsible-group-faq-index]');
      this.selectBox = this.querySelector('[data-collapsible-faq-index-select]');
      this.themeName = this.getAttribute('data-theme-name');

      if (this.tabs.length === 0 && !this.selectBox) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => this.onTabClick(event));
      });

      if (this.selectBox) {
        this.selectBox.addEventListener('change', (event) => this.onSelectChange(event));
      }

      // Activate the first tab or select option by default
      const defaultIndex = this.tabs[0]?.dataset.collapsibleFaqIndex || this.selectBox?.value;
      if (defaultIndex) {
        this.activateTab(defaultIndex);
      }
    }

    /**
     * Handle tab click event (Desktop).
     * @param {Event} event
     */
    onTabClick(event) {
      const clickedTab = event.currentTarget;
      const index = clickedTab.dataset.collapsibleFaqIndex;

      if (!index) return;

      this.activateTab(index);
      this.syncSelectBox(index);
    }

    /**
     * Handle select dropdown change event (Mobile).
     * @param {Event} event
     */
    onSelectChange(event) {
      const selectedIndex = event.target.value;

      if (!selectedIndex) return;

      this.activateTab(selectedIndex);
      this.syncTabs(selectedIndex);
    }

    /**
     * Handles multiple groups per tab.
     * @param {string} index
     */
    activateTab(index) {
      // Reset all tabs and hide all groups
      this.tabs.forEach((tab) => {
        if (this.themeName === 'liftmaster') {
          tab.classList.remove('bg-lm-grey-dark', 'text-primary-text', 'border-lm-grey-dark');
          tab.classList.add('bg-lm-grey-medium', 'border-lm-grey-medium');
        } else {
          tab.classList.remove(
            'bg-primary-secondary',
            'text-primary-text',
            'border-primary-secondary'
          );
          tab.classList.add('bg-gray-blue', 'border-gray-blue');
        }

        tab.setAttribute('aria-selected', 'false');
      });

      this.groups.forEach((group) => {
        group.classList.add('hidden');
      });

      // Activate the selected tab
      const activeTab = Array.from(this.tabs).find(
        (tab) => tab.dataset.collapsibleFaqIndex === index
      );

      if (activeTab) {
        if (this.themeName === 'liftmaster') {
          activeTab.classList.add('bg-lm-grey-dark', 'text-primary-text', 'border-lm-grey-dark');
          activeTab.classList.remove('bg-lm-grey-medium', 'border-lm-grey-medium');
        } else {
          activeTab.classList.add(
            'bg-primary-secondary',
            'text-primary-text',
            'border-primary-secondary'
          );
          activeTab.classList.remove('bg-gray-blue', 'border-gray-blue');
        }

        activeTab.setAttribute('aria-selected', 'true');
      }

      // Activate all matching groups
      const activeGroups = Array.from(this.groups).filter((group) => {
        return group.dataset.collapsibleGroupFaqIndex === index;
      });

      if (activeGroups.length > 0) {
        activeGroups.forEach((group) => {
          group.classList.remove('hidden');
        });
      }

      // Sync mobile dropdown if applicable
      if (this.selectBox) {
        this.syncSelectBox(index);
      }
    }

    /**
     * Sync the mobile select box with the active tab.
     * @param {string} index
     */
    syncSelectBox(index) {
      if (this.selectBox) {
        this.selectBox.value = index;
      }
    }

    /**
     * Sync desktop tabs with the mobile select box.
     * @param {string} index
     */
    syncTabs(index) {
      const activeTab = Array.from(this.tabs).find(
        (tab) => tab.dataset.collapsibleFaqIndex === index
      );

      if (activeTab) {
        this.tabs.forEach((tab) => {
          if (this.themeName === 'liftmaster') {
            tab.classList.remove('bg-lm-grey-dark', 'text-primary-text');
            tab.classList.add('bg-lm-grey-medium');
          } else {
            tab.classList.remove('bg-primary-secondary', 'text-primary-text');
            tab.classList.add('bg-gray-blue');
          }
        });
        if (this.themeName === 'liftmaster') {
          activeTab.classList.add('bg-lm-grey-dark', 'text-primary-text');
          activeTab.classList.remove('bg-lm-grey-medium');
        } else {
          activeTab.classList.add('bg-primary-secondary', 'text-primary-text');
          activeTab.classList.remove('bg-gray-blue');
        }
      }
    }
  }

  window.FaqTabs = FaqTabs;
  customElements.define('faq-tabs', FaqTabs);
}
